module.exports = __webpack_public_path__ + "img/UE.38159e27.png";